export function NewEventValidator(event_start, event_end) {
    var errors = false;

    var ids = [
        'account_iban',
        'account_owner',
        'registration_end',
        'last_minute_begin',
        'date_end',
        'date_begin',
        'event_location',
        'event_postalcode',
        'event_name',
        'event_email',
    ];

    for (var idx = 0; idx < ids.length; idx++) {
        var currentElement = ids[idx];

        if (document.getElementById(currentElement).value == '') {
            document.getElementById(currentElement).classList.remove('input_element_valid');
            document.getElementById(currentElement).classList.add('input_element_error');
            errors = true;
        } else {
            document.getElementById(currentElement).classList.add('input_element_valid');
            document.getElementById(currentElement).classList.remove('input_element_error');
        }
    }

    return !errors;
}

export function autoSetDates() {

    var registration_end_date = new Date(document.getElementById('date_begin').value);
    var last_minute_start_date = new Date(document.getElementById('date_begin').value);
    var event_end_date = new Date(document.getElementById('date_begin').value);

    var day_in_millisecond = 24 * 60 * 60 * 1000;
    var week_in_millisecond = 7 * day_in_millisecond;

    registration_end_date.setTime(registration_end_date.getTime() - week_in_millisecond);
    last_minute_start_date.setTime(last_minute_start_date.getTime() - week_in_millisecond * 2);
    event_end_date.setTime(event_end_date.getTime() + day_in_millisecond * 2);

    document.getElementById('registration_end').value = registration_end_date.toISOString().split('T')[0];
    document.getElementById('date_end').value = event_end_date.toISOString().split('T')[0];
    document.getElementById('last_minute_begin').value = last_minute_start_date.toISOString().split('T')[0];
}